import { useEffect } from "react";

export function useDbUpdates(enabled: boolean, onUpdate: () => void) {
    useEffect(() => {
        if (!enabled) return;

        console.log("SSE: Verbindung wird aufgebaut…");
        const eventSource = new EventSource("/api/updates/stream");

        const handler = (event: MessageEvent) => {
            console.log("SSE EVENT RECEIVED:", event.data);   // <--- HIER
            const type = event.data;
            if (type === "tour" || type === "membership") {
                onUpdate();
            }
        };

        eventSource.addEventListener("db-update", handler);

        eventSource.onerror = (err) => {
            console.error("SSE ERROR:", err);   // <--- HIER
            eventSource.close();
        };

        return () => {
            eventSource.removeEventListener("db-update", handler);
            eventSource.close();
        };
    }, [enabled, onUpdate]);
}
